import axios from 'axios'

export default  {
  namespaced: true,

  state: {
    unreadMessages: 0,
    queries: {
      page: 1,
    },
  },

  mutations: {
    getUnreadMessagesSuccess(state, unreadMessages) {
      state.unreadMessages = unreadMessages
    },

    changeSearchQuery(state, queries) {
      state.queries = queries
    },
  },

  actions: {
    searchConversation({commit}, search) {
      return new Promise((resolve, reject) => {
        axios
          .get('/conversations/search-user', {
            params: {
              search: search
            }
          })
          .then(res => {
            resolve(res.data.data.users)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getUnreadMessages({commit}) {
      return new Promise((resolve, reject) => {
        axios
          .get('/conversations/get-unread-messages')
          .then(res => {
            commit('getUnreadMessagesSuccess', res.data.data.unread_messages)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getSystem({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/conversations/get-system')
          .then(res => {
            resolve(res.data.data.system)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    all({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/conversations')
          .then(res => {
            resolve(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getMoreConversations({ commit }, queries) {
      commit('changeSearchQuery', queries)

      return new Promise((resolve, reject) => {
        axios.get('/conversations', { params: queries })
          .then(res => {
            resolve(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    startConversation({commit}, userId) {
      return new Promise((resolve, reject) => {
        axios
          .post('/conversations/new-conversation', {
            user_id: userId
          })
          .then(res => {
            resolve(res.data.data.conversation)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    readConversation({commit}, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/conversations/${token}/read-conversation`)
          .then(res => {
            commit('getUnreadMessagesSuccess', res.data.data.unread_messages)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getLastMessage({commit}, token) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/conversations/${token}/get-last-message`)
          .then(res => {
            resolve(res.data.data.message)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getMessages({commit}, token) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/conversations/${token}/get-messages`)
          .then(res => {
            resolve(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getMoreMessages({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/conversations/${data.token}/get-messages`, {
            params: data.queries
          })
          .then(res => {
            resolve(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getConversation({commit}, token) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/conversations/${token}`)
          .then(res => {
            resolve(res.data.data.conversation)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    sendMessage({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/conversations/${data.token}/send-message`, data)
          .then(res => {
            resolve(res.data.data.message)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    sendAttach({commit}, attachForm) {
      return new Promise((resolve, reject) => {
        axios.post(`/conversations/${attachForm.get('conversation_token')}/add-attach`, attachForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res.data.data.message)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    removeMessage({commit}, messageId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/conversations/messages/${messageId}/remove`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {
    unreadMessages: state => state.unreadMessages,
    queries: state => state.queries,
  },
}
